$(document).ready(function() {

  // Slider de stories
  if ($('.stories-itens').length) {
    $('.stories-itens').slick({
      infinite: false,
      slidesToShow: 8,
      slidesToScroll: 1,
      prevArrow: '<button type="button" class="slick-prev slick-arrow" style="display: block;"><svg viewBox="0 0 370.814 370.814" class="icon icon-chevron-left" id="icon-chevron-left"><g><g><polygon points="292.92,24.848 268.781,0 77.895,185.401 268.781,370.814 292.92,345.961 127.638,185.401"></polygon></g></g></svg></button>',
      nextArrow: '<button type="button" class="slick-next slick-arrow" style="display: block;"><svg viewBox="0 0 478.448 478.448" class="icon icon-chevron-right" id="icon-chevron-right"><g><g><polygon points="131.659,0 100.494,32.035 313.804,239.232 100.494,446.373 131.65,478.448 377.954,239.232"></polygon></g></g></svg></button>',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3.5,
            slidesToScroll: 1,
            arrows: false,
            vertical: false,
            dots: false
          }
        }
      ]
    });
  }

  // Slider de destaque
  if ($('#destaque-slide-home').length) {
    $('#destaque-slide-home').slick({
      arrows: true,
      prevArrow: '<button type="button" class="slick-prev slick-arrow" style="display: block;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 33"><g><g><polygon points="0 16.5 2.1 18.5 17 33 17 29.3 5.9 18.5 3.8 16.5 5.9 14.5 17 3.7 17 0 2.1 14.5 0 16.5"></polygon></g></g></svg></button>',
      nextArrow: '<button type="button" class="slick-next slick-arrow" style="display: block;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 33"><g><polygon points="14.9,14.5 0,0 0,3.7 11.1,14.5 13.2,16.5 11.1,18.5 0,29.3 0,33 14.9,18.5 17,16.5"></polygon></g></svg></button>'
    });
  }

  // Foco no campo de busca mobile
  $(document).on('click', '[data-search-mobile-toggle]', function() {
    $('input.header-search__input').focus();
  });

  // Compartilhamento nativo - usa URL e titulo da pagina atual
  var shareButton = document.querySelector('#share');
  if (shareButton) {
    shareButton.addEventListener('click', function() {
      if (typeof navigator.share === 'undefined') {
        // Fallback: copiar URL para clipboard
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(window.location.href).then(function() {
            var orig = shareButton.textContent;
            shareButton.textContent = 'Link copiado!';
            setTimeout(function() { shareButton.textContent = orig; }, 2000);
          }).catch(function() {});
        }
      } else {
        var shareTitle = document.title || '';
        var shareText = '';
        var metaDesc = document.querySelector('meta[name="description"]');
        if (metaDesc) shareText = metaDesc.getAttribute('content') || '';

        navigator.share({
          title: shareTitle,
          url: window.location.href,
          text: shareText
        })
        .then(function() {})
        .catch(function() {});
      }
    });
  }

  // UZSPACE 2026-07-13: pausa qualquer <video> da galeria do produto ao abrir o
  // zoom (Fancybox) - sem isso, um video com controls:true (Shopify video_tag)
  // mantinha sua barra nativa de play/pause visivel por cima do zoom em alguns
  // navegadores mobile (o video roda numa camada de composicao propria que nao
  // respeita sempre o z-index do overlay do Fancybox).
  $(document).on('beforeShow.fb', function() {
    document.querySelectorAll('.product-single__media video').forEach(function(v) {
      v.pause();
    });
  });

});